import apiClient from "../utils/axiosConfig";
import { getApiUrl, API_ENDPOINTS } from "../Configurations/config";

/**
 * Query Service - Handles query analytics and top queries
 */
class QueryService {
  /**
   * Get top queries for a specific date
   * @param {number} limit - Number of queries to return (default: 10)
   * @param {string} analysisDate - Date in YYYY-MM-DD format (optional, defaults to today)
   * @returns {Promise} API response with queries array
   */
  async getTopQueries(limit = 10, analysisDate = null) {
    try {
      if (!analysisDate) {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, "0");
        const day = String(today.getDate()).padStart(2, "0");
        analysisDate = `${year}-${month}-${day}`;
      }

      const params = new URLSearchParams({
        limit: limit.toString(),
        analysis_date: analysisDate,
      });

      const response = await apiClient.get(
        `${getApiUrl(API_ENDPOINTS.QUERY.TOP_QUERIES)}?${params.toString()}`
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export const queryService = new QueryService();
export default queryService;

